import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
        <div class="flex font-sans"> 
            <div class="flex-none w-50 relative">
                <img src="/assets/images/agent.jpg" alt="" class="absolute inset-0 w-full h-full object-cover" loading="lazy" />
            </div>
            <div className='content mb-5 mt-5'>
                <h1 className='text-center text-slate-700'>The 8 Billion Dollar Man</h1>
                <p className="text-center text-slate-700 p-5">
                With over $8 Billion in sales, Alex Turner has built a stellar reputation as a premier real estate agent specializing in luxury properties across New York City and the Hamptons. Ranked as the Top Agent Nationwide for Sotheby’s International Realty, Alex is renowned for his unparalleled market knowledge, discretion, and commitment to his clients. He has represented some of the world’s most prominent individuals, including Fortune 500 CEOs, renowned artists, and global entrepreneurs.
                Known for his negotiation expertise and innovative marketing strategies, Alex consistently achieves record-breaking deals. He is frequently quoted as a luxury real estate authority in outlets like The Wall Street Journal and Architectural Digest. Alex has also been an esteemed panelist at prestigious real estate summits and conferences worldwide.
                Contact Alex Turner today to discover or sell penthouse apartments, private estates, oceanfront properties, and luxury homes in New York City, Southampton, East Hampton, and beyond.</p>
                <div className="btn-wrap ">
                <Link to="/aboutInfo"  className="lp-btn">Get To Know Alex</Link>
                </div>
            </div>
    </div>
  );
};

export default About;
